module.exports = __webpack_public_path__ + "img/logo-dark.93f77c49.png";